export class BzAuthConstants {
    public static AUTH = {
        LOGOUT: {
            URL: '/api/Authentication/Logout'
        },
        TOKEN: {
            URL: 'api/Authentication/AuthenticateWithSyncToken',
            CONTENTTYPE: 'application/json'
        },
        REFRESH_TOKEN : {
            URL: 'api/Authentication/RefreshToken'
        },
        COOKIES: {
            ACCESSTOKEN: 'bizagi.auth.accesstoken',
            IDTOKEN: 'bizagi.auth.idtoken',
            LOCATION_PATHNAME: 'bizagi.auth.location.pathname',
            AUTHDATA: 'bizagi.auth.data'
        },
        PARAMS: {
            HEADER_PREFIX_BEARER: 'Bearer ',
            DEFAULT_HEADER_NAME: 'Authorization'
        }
    }
}